/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

import styled from 'styled-components';
import { BreakPoint, Color } from '../../../../asset/styles';
import Primary from '../../../../component/button/Primary';
import FooterNote from './FooterNote';

const StyledFooter = styled.div`
  border-top: solid 1px ${Color.border.ultraLightGray};
  background-color: ${Color.white};
  box-sizing: border-box;
  padding: ${props => (props.isNoteAvailable ? 0 : 16)}px 16px 16px;

  @media (min-width: ${BreakPoint.desktop}) {
    border-bottom-left-radius: 2px;
    border-bottom-right-radius: 2px;
    /*position: relative;*/
    width: 456px;

    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 1010;
  }
`;

/**
 * {@link Inquiry} - 最下部 「送信ボタン」 component
 * @param {string} actionLabel ボタン表示文字列
 * @param {object} note 注釈文字列・リンク先を含んだオブジェクト
 * @param {string} [className=''] 識別用 class name
 * @param {*} footerRef footer height 取得 Ref
 * @param {*} props React.props
 * @return {*} React.node - {@link Inquiry} - 最下部 「送信ボタン」 component
 * @constructor
 */
const Footer = ({ actionLabel, note, className = '', footerRef, ...props }) => {
  const isNoteAvailable = note && note.available;
  return (
    <StyledFooter
      className={`Footer ${className}`}
      innerRef={footerRef}
      isNoteAvailable={isNoteAvailable}
    >
      {isNoteAvailable && (
        <FooterNote
          text={note.text}
          link={note.link}
          htmlText={note.htmlText}
        />
      )}
      <Primary {...props} primary>
        {actionLabel}
      </Primary>
    </StyledFooter>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/phase2/survey/page/inquiry/node/footer/Footer.js